export const getReservations = async (welletContext, body) => {
  try {
    const result = await welletContext.apis.tickets.post(`/reservation/all`, body);
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const fetchCities = async (welletContext) => {
  try {
    const result = await welletContext.apis.tickets.get('/shows/cities');
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const lockSchedule = async (
  welletContext,
  { pax, reservationDateLocalTime, reservationType, showId, attribute },
) => {
  try {
    const result = await welletContext.apis.tickets.post('/reservation/schedule/lock', {
      pax,
      reservationDateLocalTime,
      reservationType,
      showId,
      attribute,
    });
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const lockScheduleDelete = async (
  welletContext,
  { reservationDateLocalTime, reservationType, showId, token, paxs, attribute },
) => {
  try {
    const payload = {
      token,
      reservationDateLocalTime,
      reservationType,
      showId,
      paxs,
      attribute,
    };
    const result = await welletContext.apis.tickets.delete('/reservation/schedule/lock', {
      data: payload,
      headers: { 'Content-Type': 'application/json' },
    });
    return result.data;
  } catch (error) {
    console.error(error);

    return null;
  }
};

export const getReservation = async (reservationId, welletContext) => {
  try {
    const result = await welletContext.apis.tickets.get(`/reservation/${reservationId}`);
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const putReservation = async (
  showId,
  paxs,
  customerName,
  customerLastName,
  email,
  phone,
  customerLanguage,
  comments,
  occasion,
  countryCode,
  reservationDateTime,
  totalAmount,
  products,
  lang,
  eventId,
  reservationType,
  description,
  expirationOffset,
  notificationMethod,
  externalRefCode,
  welletContext,
  currency,
  customFields,
) => {
  try {
    const result = await welletContext.apis.tickets.put('/reservation/generatereservation', {
      showId,
      paxs,
      customerName,
      customerLastName,
      email,
      CustomerPhone:phone,
      customerLanguage,
      comments: comments,
      occasion: occasion,
      countryCode: countryCode,
      reservationDateLocalTime: reservationDateTime,
      totalAmount: totalAmount,
      products: products,
      eventId,
      reservationType,
      expirationOffset,
      notificationMethod,
      externalReferenceCode: externalRefCode,
      description,
      language: null, //It shouldn't be sent, but the API sets it to "ES".
      customerCurrency: currency,
      customFields,
    });
    return result.data;
  } catch (error) {
    console.error(error);
    if (error.response && error.response.data) {
      throw new Error('reservationError.' + error.response.data.errorType);
    } else {
      throw new Error('apiError');
    }
  }
};
